import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ActionStatus } from 'thunkless';
import { useNavigationActions } from '../../../lib/navigation/use-navigation-actions.hook';
import { getBalanceUsage } from '../../../redux/app/actions/organization';
import { NavigationPaneRouteParamsContext } from '../../../lib/navigation';
import { UILoader } from '../ui-elements/UILoader';
import { orgUsageLoadingStatusSelector, orgUsageSelector } from '../../../redux/app/selectors/organization';
import { RegionUsageStats } from './RegionUsageStats';
import { TypeUsageStats } from './TypeUsageStats';
import { InboundOutboundUsageStats } from './InboundOutboundUsageStats';
import { Balance } from './Balance';

export const BalanceUsagePane = () => {
  const dispatch = useDispatch();
  const [usageType, setUsageType] = React.useState('type');
  const [allTypes, setAllTypes] = React.useState(['Type', 'Region', 'Direction']);
  const { navigate } = useNavigationActions();
  const formattedToday = () => {
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    const dd = day < 10 ? `0${day}` : day;
    const mm = month < 10 ? `0${month}` : month;

    return `${year}-${mm}-${dd}`;
  };
  const formattedLastWeek = () => {
    const today = new Date().getTime();
    const lastWeek = new Date(today - 7 * 24 * 60 * 60 * 1000);
    const day = lastWeek.getDate();
    const month = lastWeek.getMonth() + 1;
    const year = lastWeek.getFullYear();

    const dd = day < 10 ? `0${day}` : day;
    const mm = month < 10 ? `0${month}` : month;

    return `${year}-${mm}-${dd}`;
  };

  const [to, setTo] = React.useState(formattedToday());
  const [from, setFrom] = React.useState(formattedLastWeek());
  const usage = useSelector(orgUsageSelector);
  const { subdomain } = React.useContext(NavigationPaneRouteParamsContext);
  const usageLoadingStatus = useSelector(orgUsageLoadingStatusSelector);

  React.useEffect(() => {
    dispatch(getBalanceUsage({ subdomain, from: null, to: null }));
  }, []);

  if (!usageLoadingStatus || usageLoadingStatus === ActionStatus.BUSY) {
    return <div className="v4-billing avo-ui-3" style={{ height: '100%' }}><UILoader /></div>;
  }

  const handleUpdateUsageStats = () => dispatch(getBalanceUsage({
    subdomain,
    from: (new Date(from).getTime() / 1000).toString(),
    to: (new Date(to).getTime() / 1000).toString(),
  }));
  const handleSetFromDate = (e) => setFrom(e.currentTarget.value);
  const handleSetToDate = (e) => setTo(e.currentTarget.value);
  const handleGoToSupport = () => navigate({
    path: `${window.location.origin}/accounts/${subdomain}/support`,
    params: {},
  });
  const selectOptions = allTypes.map((t, i) => <option key={i} value={t}>{t}</option>);

  let stats;
  switch (usageType) {
    case 'Type':
      stats = <TypeUsageStats />;
      break;
    case 'Region':
      stats = <RegionUsageStats />;
      break;
    case 'Direction':
      stats = <InboundOutboundUsageStats />;
      break;
    default:
      stats = <TypeUsageStats />;
  }
  return (
    <div id="balance-usage-pane" className="usage-pane">
      <Balance />
      <p className="orange bold-900 mt-15 mb-10">Usage</p>
      <p className="mb-10">
        Summary of usage.&nbsp;
        <span
          role="button"
          tabIndex={0}
          style={{ cursor: 'pointer' }}
          onClick={handleGoToSupport}
          onKeyPress={handleGoToSupport}
          className="link-blue"
        >
          Learn more.
        </span>
      </p>
      <div className="table-container">
        <p className="bold-800 mb-10">Usage</p>
        <div className="filters-container-wrap">
          <div className="filters-container">
            <div className="filter">
              <p className="fsz-12">From:</p>
              <input type="date" name="from" value={from} onChange={handleSetFromDate} />
            </div>
            <div className="filter">
              <p className="fsz-12">To:</p>
              <input type="date" name="to" value={to} onChange={handleSetToDate} />
            </div>
            <button type="button" className="button sand" onClick={handleUpdateUsageStats}>
              Update
            </button>
          </div>
          <div className="select-wrapper type">
            <select
              value={usageType}
              onChange={(e) => setUsageType(e.currentTarget.value)}
            >
              {selectOptions}
            </select>
          </div>
        </div>
        <hr />
        {
          (Object.keys(usage.region).length !== 0 && usage.type.length !== 0 && (
            <div className="table-wrapper">{stats}</div>
          )) || <p className="mt-20">No data in this range</p>
        }
      </div>
    </div>
  );
};
